import React, { useCallback, useState } from "react";
import { addTeam } from "../utils/firebase.actions";
import { setJSONKey } from "../utils/localstorage.util";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  const [teamName, setTeamName] = useState("");
  const handleSubmit = useCallback(
    async (e: any) => {
      e.preventDefault();
      const teamId = await addTeam(teamName);
      setJSONKey("TEAM", { id: teamId, name: teamName });
      navigate("/game", { replace: true });
    },
    [teamName]
  );

  return (
    <section className="home-container">
      <form onSubmit={handleSubmit}>
        <h3>Enter team name </h3>
        <input
          type="text"
          value={teamName}
          onChange={(e) => {
            setTeamName(e.target.value);
          }}
          required
        />
        <button>Start</button>
      </form>
    </section>
  );
}
